import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { PlanType } from 'types/models';
import { initialState } from '.';

export const DEPRECATED_PLAN_TYPES: PlanType[] = ['core_v1(Deprecated)'];

const selectSlice = (state: RootState) => state.preloadState || initialState;

export const selectPreloadState = createSelector([selectSlice], state => state);

export const selectPreloadSubPlan = createSelector(
  [selectSlice],
  state => state.subPlanType,
);

export const selectPreloadSsoConnectionType = createSelector(
  [selectSlice],
  state => {
    let { loading, data, error } = state.companySsoConnectionType;
    if (!loading && !error && data?.contents?.length) {
      return data.contents;
    }

    return [{ code: 'none', label: 'None' }];
  },
);

export const selectPreloadSsoConnectionTypeWithLoading = createSelector(
  [selectSlice],
  state => state.companySsoConnectionType,
);

export const selectPreloadSubPlanSearchable = createSelector(
  [selectPreloadSubPlan],
  ({ loading, data, error }) => {
    if (!loading && !error && data?.contents?.length) {
      return data.contents.map(planType => ({
        value: planType.plan_type,
        label: planType.plan_type,
      }));
    }

    return [
      { value: 'core', label: 'core' },
      { value: 'enterprise', label: 'enterprise' },
      { value: 'core_v1(Deprecated)', label: 'core_v1 (Deprecated)' },
    ];
  },
);
